import { Injectable } from '@angular/core';
import { HttpInterceptor } from '../shared/index';
import 'rxjs/add/operator/map';
import { CONSTANT_VALUES } from '../constants/constant-values';
import { environment } from '../../environments/environment';
import { Feedback } from './feedback';

@Injectable()
export class FeedbackService {
    constructor(private http: HttpInterceptor) {
    }
    /**
     * Get feedback list by specific vendor
     * 
     * @param {any} feedbackObj 
     * @returns 
     * 
     * @memberOf FeedbackService
     */
    getFeedbackByVendor(feedbackObj) {
        let url = CONSTANT_VALUES.URL_GET_FEEDBACK_LIST;
        return new Promise((resolve, reject) => {
            this.http.post(url, feedbackObj).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }
    /**
     * Send response to feedback
     * 
     * @param {any} feedbackObj 
     * @returns 
     * 
     * @memberOf FeedbackService
     */
    feedbackResponse(feedbackObj) {
        let url = CONSTANT_VALUES.URL_FEEDBACK_REPLY;
        return new Promise((resolve, reject) => {
            this.http.post(url, feedbackObj).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }
    /**
     * Forward feedback to specified email ids.
     * 
     * @param {any} feedbackObj 
     * @returns 
     * 
     * @memberOf FeedbackService
     */
    feedbackFOrword(feedbackObj) {
        let url = CONSTANT_VALUES.URL_FEEDBACK_FORWARD;
        return new Promise((resolve, reject) => {
            this.http.post(url, feedbackObj).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/feedback/feedback.service.ts